export default {
  rounded: { borderRadius: 20 },
  root: {
    "&.MuiMenu-paper.MuiPopover-paper": {
      boxShadow: "2px 16px 40px rgba(0, 12, 45, 0.05)",
      padding: 13,
    },
  },
};
